import React, { useState, useEffect } from 'react';
import { Form } from 'antd';
import { useAppDispatch } from '../../../../hooks/redux';
import {
    AddProductsFromAnotherProjectModal,
    AddFromAProjectSpace,
} from '../AddFromAProjectModal/AddFromAProjectModal.styles';
import { Text, CloseIcon } from '../../../../styles/common.styles';
import CustomSelectWithSearch from '../../../common/select/CustomSelectWithSearch';
import ModalTitle from '../../../common/modalTitle/ModalTitle';
import ModalFooter from '../../../common/modalFooter/ModalFooter';
import { blueDark01 } from '../../../../styles/colors';
import { ActionResponse } from '../../../../models/actionResponse/types';
import { getLiveGuidelinesListAction } from '../../../../redux/actions/liveGuidelineActions';
import { LiveGuideline } from '../../../../redux/actions/liveGuidelineActions/types';
import { SelectData } from '../../../../models/common/types';

interface Props {
    isOpen: boolean;
    projectId?: number;
    closeModal: () => void;
}

const AddFromALiveGuidelineModal: React.FC<Props> = ({ isOpen, closeModal, projectId }) => {
    const dispatch = useAppDispatch();
    const [guidelineOptions, setGuidelineOptions] = useState<SelectData[]>([]);

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const fetchGuidelines = async () => {
            // GetList returns a plain array with no total, so ask for a large page like the list page does.
            const { payload } = (await dispatch(
                getLiveGuidelinesListAction({ curPage: 1, pageSize: 1000 }),
            )) as ActionResponse<LiveGuideline[]>;

            const options = (payload?.data ?? [])
                .map((guideline) => ({ id: guideline.id.toString(), name: guideline.name }))
                .sort((a, b) => a.name.localeCompare(b.name));

            setGuidelineOptions(options);
        };

        fetchGuidelines();
    }, [dispatch, isOpen]);

    const onSubmit = (data: { selectedLiveGuideline: string }) => {
        if (data.selectedLiveGuideline) {
            // Tab "1" is the Products tab; full reload matches how "Add from a Project" navigates.
            window.location.href = `/live-guidelines/${data.selectedLiveGuideline}/1?copyProductsTo=${projectId}`;
        }
    };

    return (
        <AddProductsFromAnotherProjectModal
            open={isOpen}
            onCancel={closeModal}
            closeIcon={<CloseIcon />}
            centered
            footer={null}
        >
            <ModalTitle title="Select a Live Guideline" icon="ic-modal-title-start-add-project.svg" />
            <Text weight={400} size={15} height={20} color={blueDark01}>
                Select the Live Guideline with the products you want to add.
            </Text>
            <Form onFinish={onSubmit}>
                <AddFromAProjectSpace>
                    <CustomSelectWithSearch
                        id="LiveGuidelinesToCopySelectModal"
                        label="Select Live Guideline"
                        name="selectedLiveGuideline"
                        options={guidelineOptions}
                        placeholder="Select one"
                        rules={[{ message: '' }]}
                        block
                        modallabel
                    />
                </AddFromAProjectSpace>
                <ModalFooter action="Next" cancelText="Cancel" cancel={closeModal} submit={() => {}} />
            </Form>
        </AddProductsFromAnotherProjectModal>
    );
};

export default AddFromALiveGuidelineModal;
